import { SdkEventInterface } from "@modules/sdk/events/SdkEventInterface";

import { COMMON_SDK_EVENTS } from "../constants";

class WidgetOpenedSdkEvent implements SdkEventInterface {
    public readonly type = COMMON_SDK_EVENTS.WIDGET_OPENED;
    public readonly widgetName: string;

    constructor(widgetName: string) {
        this.widgetName = widgetName;
    }
}

export default WidgetOpenedSdkEvent;
